/**
 * PlacementTableSummary - Summary bar for PlacementTableView
 *
 * Sticky bottom bar showing filtered results and quick statistics.
 */

import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface PlacementTableSummaryProps {
  totalCount: number;
  filteredCount: number;
  placedCount: number;
  unplacedCount: number;
}

export const PlacementTableSummary: React.FC<PlacementTableSummaryProps> = ({
  totalCount,
  filteredCount,
  placedCount,
  unplacedCount,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        bgcolor: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(8px)',
        borderTop: '1px solid rgba(0,0,0,0.06)',
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: '11px',
          fontWeight: 500,
          color: 'text.primary',
        }}
      >
        {t('screens.ramp.autoPark.placementTable.summary.showing', {
          filtered: filteredCount,
          total: totalCount
        })}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          fontSize: '11px',
          color: 'text.disabled',
        }}
      >
        •
      </Typography>

      <Typography
        variant="body2"
        sx={{
          fontSize: '11px',
          color: '#10B981',
          fontWeight: 600,
        }}
      >
        {t('screens.ramp.autoPark.placementTable.summary.placed', { count: placedCount })}
      </Typography>

      {unplacedCount > 0 && (
        <>
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              color: 'text.disabled',
            }}
          >
            •
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              color: '#EF4444',
              fontWeight: 600,
            }}
          >
            {t('screens.ramp.autoPark.placementTable.summary.unplaced', { count: unplacedCount })}
          </Typography>
        </>
      )}
    </Box>
  );
};
